import Axios from "axios";
import { getIdpApiBase } from "./idpBase";

export const uploadImageApi = ({ authToken, deviceId, userId, merchantId, file }) => {
	var bodyFormData = new FormData();
	bodyFormData.set("file", file);
	bodyFormData.set("memberId", userId);
	bodyFormData.set("merchantId", merchantId);
	return Axios({
		method: "post",
		url: window.ApiURL + "dashboard/upload/image",
		data: bodyFormData,
		headers: {
			"Content-Type": "application/x-www-form-urlencoded",
			authToken: authToken,
			deviceUniqueId: deviceId,
		},
	});
};

/** Public — no auth headers (idp-service). */
export const getListCountryApi = () => {
	return Axios({
		method: "get",
		url: getIdpApiBase() + "v2/locations/countries",
		params: {
			asean: true,
			active: true,
		},
	});
};

export const getListProvinceApi = ({ id }) => {
	return Axios({
		method: "get",
		url: getIdpApiBase() + "v2/locations/countries/" + id + "/provinces",
	});
};

export const getListCityApi = ({ id }) => {
	return Axios({
		method: "get",
		url: getIdpApiBase() + "v2/locations/provinces/" + id + "/cities",
	});
};

/** Public — no auth headers (idp-service). */
export const getListIndustryApi = () => {
	return Axios({
		method: "get",
		url: getIdpApiBase() + "v2/merchant/registrations/options",
	});
};
